module.exports = __webpack_public_path__ + "img/server07.a2e96446.jpg";